// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.accountview.properties.RentalManagerAccountViewZrmV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  AccountViewListingGroupsResponseDto,
  AccountViewListingOptionsDto,
  AccountViewMultiplexUnitsResponseDto,
  AccountViewTableCellDto,
  ListingAlias,
} from '../..';

interface InquiriesParams {
  groupId: string;
  includeActive?: boolean;
  includeArchived?: boolean;
  includeInactive?: boolean;
  includeUnarchived?: boolean;
  listingAlias?: ListingAlias;
  searchText?: string;
}
interface LeasesParams {
  groupId: string;
  includeActive?: boolean;
  includeArchived?: boolean;
  includeInactive?: boolean;
  includeUnarchived?: boolean;
  listingAlias?: ListingAlias;
  searchText?: string;
}
interface ListParams {
  includeActive?: boolean;
  includeArchived?: boolean;
  includeInactive?: boolean;
  includeUnarchived?: boolean;
  limit?: number;
  searchText?: string;
  startKeyExclusive?: string;
}
interface OptionsParams {
  listingAlias: ListingAlias;
}
interface PaymentsParams {
  groupId: string;
  includeActive?: boolean;
  includeArchived?: boolean;
  includeInactive?: boolean;
  includeUnarchived?: boolean;
  listingAlias?: ListingAlias;
  searchText?: string;
}
interface UnitsParams {
  groupId: string;
  includeActive?: boolean;
  includeArchived?: boolean;
  includeInactive?: boolean;
  includeUnarchived?: boolean;
  limit?: number;
  searchText?: string;
  startKeyExclusive?: string;
}

export const RentalManagerAccountViewZrmV2WebApiHandler_inquiries_Path =
  '/api/web/v2/users/accountView/zrm/properties/inquiries';

/**
 * Get zrm user account view property inquiries status
 */
export const RentalManagerAccountViewZrmV2WebApiHandler_inquiries = (
  getParams: InquiriesParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<InquiriesParams, never, AccountViewTableCellDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAccountViewZrmV2WebApiHandler_inquiries_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerAccountViewZrmV2WebApiHandler_leases_Path =
  '/api/web/v2/users/accountView/zrm/properties/leases';

/**
 * Get zrm user account view property leases status
 */
export const RentalManagerAccountViewZrmV2WebApiHandler_leases = (getParams: LeasesParams, client = getClient()) => {
  return httpFrontEndRequest<LeasesParams, never, AccountViewTableCellDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAccountViewZrmV2WebApiHandler_leases_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerAccountViewZrmV2WebApiHandler_list_Path = '/api/web/v2/users/accountView/zrm/properties/list';

/**
 * Get zrm user account view property list with multiplex groups view
 */
export const RentalManagerAccountViewZrmV2WebApiHandler_list = (getParams: ListParams, client = getClient()) => {
  return httpFrontEndRequest<ListParams, never, AccountViewListingGroupsResponseDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAccountViewZrmV2WebApiHandler_list_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerAccountViewZrmV2WebApiHandler_options_Path =
  '/api/web/v2/users/accountView/zrm/properties/options';

/**
 * Get account view property listing options
 */
export const RentalManagerAccountViewZrmV2WebApiHandler_options = (getParams: OptionsParams, client = getClient()) => {
  return httpFrontEndRequest<OptionsParams, never, AccountViewListingOptionsDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAccountViewZrmV2WebApiHandler_options_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerAccountViewZrmV2WebApiHandler_payments_Path =
  '/api/web/v2/users/accountView/zrm/properties/payments';

/**
 * Get zrm user account view property payments status
 */
export const RentalManagerAccountViewZrmV2WebApiHandler_payments = (
  getParams: PaymentsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<PaymentsParams, never, AccountViewTableCellDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAccountViewZrmV2WebApiHandler_payments_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerAccountViewZrmV2WebApiHandler_units_Path =
  '/api/web/v2/users/accountView/zrm/properties/multiplex/units';

/**
 * Get zrm user account view unit list for a multiplex
 */
export const RentalManagerAccountViewZrmV2WebApiHandler_units = (getParams: UnitsParams, client = getClient()) => {
  return httpFrontEndRequest<UnitsParams, never, AccountViewMultiplexUnitsResponseDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAccountViewZrmV2WebApiHandler_units_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
